import "./Header.scss";
import logo from "../assets/images/logo_eVHC.png";
import CodeSelectBox from "../components/common/CodeSelectBox";
import { useState } from "react";
import i18n from "../services/i18n";
import { Link } from "react-router-dom";

const SimpleHeader = () => {
  const [lang, setLang] = useState(i18n.language);
  const sbLang = [{ code: "eng", codeDesc: "English" }];

  const handleLangChange = (e) => {
    setLang(e.target.value);
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div>
      <div id="header_wrap">
        <div className="header">
          <h1>
            <Link to="/login">
              <img src={logo} alt="Logo" />
            </Link>
          </h1>
          <div className="top_right">
            <CodeSelectBox
              width="140px"
              value={lang}
              codes={sbLang}
              onChange={handleLangChange}
            ></CodeSelectBox>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleHeader;
